import React, { useContext } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { observer } from "mobx-react";
import styled from "styled-components";
import ImportSheetPopup from "./ImportSheetPopup";
import { PackStoreContext } from "app/Pack/PackStore.js";

function CreateSheet(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [importPopupAnchorEl, setImportPopupAnchorEl] = React.useState(null);
  const [isOpen, setOpen] = React.useState(false);
  const store = useContext(PackStoreContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setImportPopupAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleImportSheetPopup = () => {
    setOpen(true);
    handleClose();
  };

  const handleSheetCreation = () => {
    store.handleCreateSheet();
    handleClose();
  };

  const handleUseAssistant = () => {
    window.appStore.assistantStore.openChat()
    handleClose();
  }

  return (
    <StyledMenu>
      <div onClick={handleClick}>Add Sheet +</div>
      <Menu
        id="Add-Sheet"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        disableAutoFocusItem={true}
      >
        <MenuItem onClick={handleSheetCreation}>
          Create Tigersheet from Scratch
        </MenuItem>
        <MenuItem onClick={handleImportSheetPopup}>
          Import from Spreadsheet
        </MenuItem>
        <MenuItem onClick={handleUseAssistant}>Use Tigersheet Assistant</MenuItem>
      </Menu>
      <ImportSheetPopup
        anchorEl={importPopupAnchorEl}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
      ></ImportSheetPopup>
    </StyledMenu>
  );
}

const StyledMenu = styled.div`
  padding-right: 20px;
`;

export default observer(CreateSheet);
